module.exports = __webpack_public_path__ + "static/media/satisfaction.a610dd84.jpg";